import React, { useEffect, useMemo, useState } from "react";

const RALLY_START = new Date("2026-08-13T00:00:00");

function getTimeRemaining(targetDate) {
  const now = new Date();
  const diffMs = targetDate.getTime() - now.getTime();

  if (diffMs <= 0) {
    return {
      expired: true,
      totalMs: 0,
      days: 0,
      hours: 0,
      minutes: 0,
    };
  }

  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  return {
    expired: false,
    totalMs: diffMs,
    days,
    hours,
    minutes,
  };
}

export default function RallyCountdownWidget() {
  const [tick, setTick] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setTick(Date.now());
    }, 60 * 1000); // update every minute

    return () => window.clearInterval(timer);
  }, []);

  const remaining = useMemo(() => {
    return getTimeRemaining(RALLY_START);
  }, [tick]);

  return (
    <div className="jp-stat-widget jp-stat-widget--countdown">
      <div className="jp-stat-label">Countdown to rally</div>

      {remaining.expired ? (
        <>
          <div className="jp-stat-value">It’s here</div>
          <div className="jp-stat-sub">Jampot Rally 2026 has begun</div>
        </>
      ) : (
        <>
          <div className="jp-countdown-units" aria-label="Time remaining until the rally starts">
            <span>
              <strong>{remaining.days}</strong>
              day{remaining.days === 1 ? "" : "s"}
            </span>
            <span>
              <strong>{remaining.hours}</strong>
              hour{remaining.hours === 1 ? "" : "s"}
            </span>
            <span>
              <strong>{remaining.minutes}</strong>
              min{remaining.minutes === 1 ? "" : "s"}
            </span>
          </div>
          <div className="jp-stat-sub">to go</div>
        
        </>
      )}
    </div>
  );
}
